"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.customProperty = void 0;
exports.customProperty = function (axios) {
    return {
        getCustomPropertyUsable: function () {
            return axios.get('/custom-properties/usable');
        },
        getCustomProperties: function () {
            return axios.get('/custom-properties');
        },
        getCustomPropertiesValues: function (getCustomPropertiesValuesRequest) {
            return axios.get("/custom-properties/values/" + getCustomPropertiesValuesRequest.params.propertyValueNo);
        },
        postCustomProperties: function (postCustomPropertiesRequest) {
            if (!postCustomPropertiesRequest.headers) {
                return axios.post('/custom-properties', postCustomPropertiesRequest.data);
            }
            var config = {
                headers: __assign({}, postCustomPropertiesRequest.headers)
            };
            return axios.post('/custom-properties', postCustomPropertiesRequest.data, config);
        },
        deleteCustomPropertiesPropertyNo: function (_a) {
            var pathParams = _a.pathParams;
            return axios.delete("/custom-properties/" + pathParams.propertyNo);
        }
    };
};
